import { FunctionComponent, useEffect, useRef, useState } from "react";

interface CarouselProps {
  images: string[];
  autoPlay?: boolean;
  showButtons?: boolean;
}

const Carousel: FunctionComponent<CarouselProps> = (props: CarouselProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [selectedImage, setSelectedImage] = useState<string>(props.images[0]);
  const [loaded, setLoaded] = useState<boolean>(false);
  const logoRef: any = useRef();

  useEffect(() => {
    if (props.autoPlay || !props.showButtons) {
      const interval = setInterval(() => {
        selectNewImage(selectedIndex, props.images);
      }, 5000);
      return () => clearInterval(interval);
    }
  });

  const selectNewImage = (index: number, images: string[], next = true) => {
    setLoaded(false);
    setTimeout(() => {
      const condition = next
        ? selectedIndex < images.length - 1
        : selectedIndex > 0;
      const nextIndex = next
        ? condition
          ? selectedIndex + 1
          : 0
        : condition
        ? selectedIndex - 1
        : images.length - 1;
      setSelectedImage(images[nextIndex]);
      setSelectedIndex(nextIndex);
    }, 800);
  };

  const previous = () => {
    selectNewImage(selectedIndex, props.images, false);
  };

  const next = () => {
    selectNewImage(selectedIndex, props.images);
  };

  return (
    <>
      <div className="carouselContainer no-select">
        <div className="carouselButtonsContainer">
          {props.showButtons ? (
            <>
              <button className="button" onClick={previous}>
                {"<"}
              </button>
              <button className="button" onClick={next}>
                {">"}
              </button>
            </>
          ) : (
            ""
          )}
        </div>
        {selectedIndex == 0 ? (
          <div
            ref={logoRef}
            className={
              loaded
                ? "logoCarousel animate__animated animate__fadeIn animate_slow activeLogo"
                : "logoCarousel animate__animated animate__fadeIn animate_slow"
            }
          >
            <p className=" animate__animated animate__backInDown animate__fast">
              Diesel Constructora
            </p>
          </div>
        ) : (
          ""
        )}
        <img
          src={`./assets/images/${selectedImage}`}
          alt="Image"
          className={loaded ? "active carouselImg" : "carouselImg"}
          onLoad={() => {
            setLoaded(true);
          }}
          loading="lazy"
        />
      </div>
    </>
  );
};

export default Carousel;
